import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'app/pages/AgentPricing/actionTypes';
import { getRatesTable, getRatesHighlightInfo } from 'app/pages/AgentPricing/modules/RatesTableWidget/selectors';
import { RatesTable, RatesColumn } from 'app/pages/AgentPricing/models';
import { RatesHighlight } from 'app/pages/AgentPricing/modules/RatesTableWidget/state';
import { changeRate, changeStartDate, changeEndDate } from 'app/pages/AgentPricing/actions';
import { RatesTableWidget } from 'app/pages/AgentPricing/components/RatesTableWidget/RatesTableWidget';

export interface MainRatesTableProps {
    readonly?: boolean
}

interface StateProps {
    table: RatesTable, 
    readonly: boolean
    columns: RatesColumn[], 
    highlightInfo: RatesHighlight
}

interface DispatchProps {
    onChangeRate: (columnId: string, rowId: string, rate: string) => void,
    onChangeStartDate: (newDate: string) => void,
    onChangeEndDate: (newDate: string | null) => void
}

const mapStateToProps = (state:any, ownProps: MainRatesTableProps) => {
    const ratesTable = getRatesTable(state); 
    const highlightInfo = getRatesHighlightInfo(state); 

    let columns : RatesColumn[] = []; 

    if (ratesTable != undefined) {
        ratesTable.countries.forEach(x => {
            columns = columns.concat(x.columns); 
        })
    }

    return { 
        readonly: ownProps.readonly,
        table: ratesTable, 
        columns: columns,
        highlightInfo: highlightInfo
    }
};

const mapDispatchToProps = (dispatch:ThunkDispatch<any, any, Action>, ownProps: MainRatesTableProps) : DispatchProps => {
    const onChangeRate = ownProps.readonly
        ? (columnId: string, ruleId: string, rate: string) => {}
        : (columnId: string, ruleId: string, rate: string) => dispatch(changeRate(columnId, ruleId, rate));

    const onChangeStartDate = ownProps.readonly
        ? (newDate: string) => {}
        : (newDate: string) => dispatch(changeStartDate(newDate));

    const onChangeEndDate = ownProps.readonly
        ? (_newDate: string | null) => {}
        : (newDate: string | null) => dispatch(changeEndDate(newDate));

    return {
        onChangeRate,
        onChangeStartDate,
        onChangeEndDate
    };
}

export const MainRatesTable = connect(mapStateToProps, mapDispatchToProps)(RatesTableWidget);

